import { breakpoints } from "src/styles/breakpoints"
import styled from "styled-components"

export const APPLICATION_CONTENT_MAX_WIDTH = 1170

export const MainContent = styled.div`
  @media (min-width: ${breakpoints.sm}) {
    max-width: ${APPLICATION_CONTENT_MAX_WIDTH}px;
  }
  width: 100%;
  padding: 0 16px;
  max-width: 100%;
  flex: 1;
  margin: 0 auto;
`
